import { IUser } from '@novakid/ts-types';

export function getUserRole(userGroup: IUser['group']) {
  if (userGroup === 'admins' || userGroup === 'services') {
    return 'observer';
  }

  if (userGroup === 'teachers') {
    return 'teacher';
  }

  return 'student';
}
